// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ul_box[data-v-00cb7b82] {\n  overflow: hidden;\n}\n.ul_box li[data-v-00cb7b82] {\n  float: left;\n  padding-left: 10px;\n  width: 150px !important;\n  height: 30px;\n  line-height: 30px;\n}\n\n", ""]);
// Exports
module.exports = exports;
